import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'indexToCoverName',
})
export class IndexToCoverNamePipe implements PipeTransform {
    transform(value: any, args?: any): any {
        if (!value) {
            return value;
        }
        return value.replace('-1', 'כריכה');
    }
}
